<template>
  <div class="container w-full h-full k-photochromatic mt-2 mb-4 py-4 md:py-0 md:mr-8">
    <ImgComparisonSlider style="--divider-width:2px;--default-handle-width:100px;--default-handle-width:clamp(40px, 10vw, 200px);">
      <!-- eslint-disable -->
      <figure slot="first" style="margin: 0;background: black;border-radius: 0px;border-radius: 0px;color: white;padding: 0px;position: absolute;top: 50%;transform: translateY(-50%);line-height: 100%;left: 0px;">
        <img style="width: 100%;" hover="true" :src="rightImg"/>
        <figcaption style="margin-left: 1em;">{{rightText}}</figcaption>
      </figure>
      <figure slot="second" style="margin: 0;background: black;border-radius: 0px;border-radius: 0px;color: white;padding: 0px;line-height: 100%;left: 0px;transform: translateY(0%);text-align: right;">
        <img style="width: 100%" hover="true" :src="leftImg"/>
        <figcaption style="margin-right: 1em;">{{leftText}}</figcaption>
      </figure> 
      <svg slot="handle" xmlns="http://www.w3.org/2000/svg" width="100" viewBox="-8 -3 16 6">
       <path stroke="black" d="M -5 -2 L -7 0 L -5 2 M -5 -2 L -5 2 M 5 -2 L 7 0 L 5 2 M 5 -2 L 5 2" stroke-width="1" fill="#fff" vector-effect="non-scaling-stroke"></path>
      </svg>
      <template #icon-handle>
        <KIcon name='handle' class="h-full transform -translate-x-1/2"/>
      </template>
      <!-- eslint-enable -->
    </ImgComparisonSlider>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { KIcon } from '@/components'
import { ImgComparisonSlider } from '@img-comparison-slider/vue'

export default defineComponent({
  name: 'Photochromatic',
  components: {
    ImgComparisonSlider,
    KIcon
  },
  props: {
    rightImg: {
      type: String,
      required: true
    },
    leftImg: {
      type: String,
      required: true
    },
    rightAlt: {
      type: String,
      default: ''
    },
    leftAlt: {
      type: String,
      default: ''
    },
    rightText: {
      type: String,
      default: ''
    },
    leftText: {
      type: String,
      default: ''
    }
  }
})
</script>
